import { Component, OnInit, HostListener } from '@angular/core';
import { AdministradorService } from '../administrador.service';
import { MatDialog } from '@angular/material/dialog';
import { AdministradorComponent } from '../administrador.component';
import { TablesService } from 'src/app/generico/tables/tables.service';

@Component({
  selector: 'app-usuario-admin',
  templateUrl: './usuario-admin.component.html',
  styleUrls: ['./usuario-admin.component.scss']
})
export class UsuarioAdminComponent implements OnInit {

  recurso ='aplicaciones/';
  columnas = ['nombre', 'apellidos', 'usuario', 'telefono', 'estado', 'acciones'];
  nombre_tabla = 'tabla-administradores';
  target
  params = {}

  constructor(private admin_serv : AdministradorService,
              private dialog: MatDialog,
              private tb_serv : TablesService) { }

  ngOnInit(): void {

    this.recurso = this.recurso+this.admin_serv.id_aplicacion+'/administradores';
    this.target = document.querySelector('#btn_crear_admin');

  }

  ver_crear_administrador(){
    let dialogRef = this.dialog.open(AdministradorComponent, {
      width: '500px',
    });

    dialogRef.afterClosed()
             .subscribe(
               ()=>{
                 this.tb_serv.tablas[this.nombre_tabla].cargar_datos(this.params);
                 this.admin_serv.json_usuario = null;
               }
             );
    this.admin_serv.dialog_crearuser = dialogRef;
  }

  @HostListener('editar_usuario_admin')
  editar_usuario_admin(){
    this.admin_serv.json_usuario = this.tb_serv.params_event.usuario;
    this.ver_crear_administrador();
  }

}
